<template>
    <v-overlay :model-value="loading"
               class="align-center justify-center">
        <v-progress-circular color="primary"
                             indeterminate
                             size="64"></v-progress-circular>
    </v-overlay>
    <v-btn :prepend-icon="tag.icon"
           class="mr-1"
           @click="openDialog"
           variant="flat"
           :loading="loading"
           color="grey-lighten-2">
        View {{ tag.name }}
    </v-btn>
    <v-dialog v-model="showMakeAndHold"
              width="900"
              scrollable>
        <v-card>
            <v-toolbar dark
                       color="primary">
                <v-toolbar-title><v-icon :icon="tag.icon"></v-icon> {{ tag.name }}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon
                       dark
                       @click="showMakeAndHold = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-table density="comfortable" class="w-100">
                    <thead>
                        <tr>
                            <th class="text-left">Colour</th>
                            <th class="text-right">Stock Level</th>
                            <th class="text-right">Stock Required</th>
                            <th class="text-right">Difference</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="colour in colours" :key="colour.id">
                            <td>
                                <router-link :to="'/'+$constants.entities.Colour.ROUTE+colour.id" @click="showMakeAndHold = false">{{ colour.code }} - {{ colour.name }}</router-link>
                                <entity-tag-chip :object="{ entityType: 'Colour', tag: colour.tag }" class="ml-1"></entity-tag-chip>
                            </td>
                            <td class="text-right">{{ numberWithCommas(colour.stockLevel, 2) }}</td>
                            <td class="text-right">{{ numberWithCommas(colour.stockRequired, 2) }}</td>
                            <td class="text-right" :class="{ 'text-red-darken-2 font-weight-bold': difference(colour) < 0 }">{{ numberWithCommas(difference(colour), 2) }}</td>
                        </tr>
                        <tr v-if="colours.length == 0">
                            <td colspan="5" class="text-center">No colours are tagged as {{ tag.name }}.</td>
                        </tr>
                    </tbody>
                </v-table>
            </v-card-text>
            <v-card-actions>
                <v-btn dark @click="showMakeAndHold = false">
                    CLOSE
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<style scoped>
</style>
<script>
    import { mapActions, mapState } from "vuex";
    import { numberWithCommas } from "../../mixins/numberMixins";
    import { getColourTagDetails } from "../../mixins/colourMixins";
    import colourConstants from "@/constants/modules/colours";
    export default {
        name: "ColourOverviewToolbar",
        data: function () {
            return {
                loading: false,
                showMakeAndHold: false,
                colours: []
            };
        },
        props: {
        },
        methods: {
            numberWithCommas,
            ...mapActions([
                "showErrorSnack"
            ]),
            difference(colour) {
                return colour.stockLevel - colour.stockRequired;
            },
            openDialog() {
                this.loading = true;
                this.$api.get('colours/makeandhold')
                    .then(res => {
                        this.colours = res.data;
                        this.loading = false;
                        this.showMakeAndHold = true;
                    })
                    .catch(error => {
                        this.loading = false;
                        this.showErrorSnack('There was an error loading the make and hold colours.');
                    });
            }
        },
        computed: {
            ...mapState({
                entity: (state) => state.entities.entity
            }),
            tag() {
                return getColourTagDetails(colourConstants.TAG_MAH);
            }
        },
    };
</script>
